import CompetitionsAdapterContainer from './competitions_adapter_container';

export default CompetitionsAdapterContainer;
